var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgVolumeOff = function SvgVolumeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.145 20.854l-17-17 .707-.708 17 17-.707.708z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 8.538h3.074l.547-.356-.723-.723-.12.079H3.25C2.014 7.538 1 8.543 1 9.768v4.463c0 1.226 1.014 2.231 2.25 2.231h2.777L13 21v-6.69l-1-1v5.846l-5.676-3.694H3.25c-.692 0-1.25-.565-1.25-1.23V9.768c0-.666.558-1.231 1.25-1.231zM12 11.896l1 1V3L7.005 6.901l.723.723L12 4.844v7.052z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 14a2 2 0 100-4v1a1 1 0 110 2v1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.778 16.675A5.002 5.002 0 0015 7v1a4 4 0 01.982 7.879l.796.796zM15 16.31V17c.22 0 .436-.014.648-.042L15 16.311z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.021 18.918A8 8 0 0015 4v1a7 7 0 013.286 13.182l.735.736zm-1.719-.305A6.99 6.99 0 0115 19v1c1.09 0 2.13-.218 3.076-.613l-.774-.774z"
  })));
};
export default SvgVolumeOff;